<template>
  <section
    :class="{ 'home-banner--image': backgroundUrl }"
    :style="backgroundStyle"
    class="home-banner"
  >
    <div v-if="backgroundUrl" class="home-banner__overlay"></div>
    <div class="home-banner__container">
      <div class="home-banner__content">
        <h1>{{ title }}</h1>
        <p v-if="description">{{ description }}</p>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true
    },
    description: {
      type: String,
      default: ''
    },
    backgroundUrl: {
      type: String,
      default: require('@/assets/images/lunbo/3.jpg')
    }
  },
  computed: {
    backgroundStyle() {
      return this.backgroundUrl ? { backgroundImage: `url(${this.backgroundUrl})` } : {}
    }
  }
}
</script>

<style lang="scss" scoped>
.home-banner {
  position: relative;
  min-height: 720px;
  background: linear-gradient(90deg, rgba(14, 32, 55, .78), rgba(14, 32, 55, .28) 62%, rgba(14, 32, 55, .1));
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  color: #fff;
}
.home-banner__overlay {
  position: absolute;
  z-index: 1;
  inset: 0;
  background: linear-gradient(90deg, rgba(14, 32, 55, .78), rgba(14, 32, 55, .28) 62%, rgba(14, 32, 55, .1));
  pointer-events: none;
}
.home-banner__container {
  position: relative;
  z-index: 2;
  display: flex;
  width: calc(100% - 64px);
  max-width: 1200px;
  min-height: 720px;
  align-items: center;
  margin: 0 auto;
  padding-top: 72px;
}
.home-banner__content {
  max-width: 620px;
}
.home-banner__content h1 {
  margin: 0;
  font-size: clamp(42px, 4.2vw, 64px);
  font-weight: 600;
  line-height: 1.25;
  letter-spacing: .03em;
}
.home-banner__content p {
  max-width: 600px;
  margin: 26px 0 0;
  color: rgba(255, 255, 255, .86);
  font-size: 18px;
  line-height: 1.85;
}
@media (max-width: 1024px) {
  .home-banner, .home-banner__container {
    min-height: 620px;
  }
}
@media (max-width: 768px) {
  .home-banner, .home-banner__container {
    min-height: 580px;
  }
  .home-banner__container {
    width: calc(100% - 40px);
    padding-top: 64px;
  }
  .home-banner__content h1 {
    font-size: 38px;
  }
  .home-banner__content p {
    margin-top: 18px;
    font-size: 15px;
  }
}
@media (max-width: 480px) {
  .home-banner, .home-banner__container {
    min-height: 460px;
  }
  .home-banner__container {
    width: calc(100% - 32px);
    padding-top: 48px;
  }
  .home-banner__content h1 {
    font-size: 32px;
  }
  .home-banner__content p {
    font-size: 14px;
    line-height: 1.7;
  }
}
</style>
